// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ff7cc5f8","233":"d81f2e9d","258":"996d492f","449":"474a8934","815":"3b6a72d2","834":"864a0633","948":"2564606f","968":"6d5acce3","976":"0bcc53e1"}[chunkId] + ".chunk.js";
};